import { useRef } from 'react';
import type { HighlightableApi } from './HighlightablePaper';

export function useHighlightListItem() {
  const itemRefs = useRef<({ id: string; api: HighlightableApi } | null)[]>([]);

  const addRef = (index: number, id: string, api: HighlightableApi | null) => {
    itemRefs.current[index] =
      api === null
        ? null
        : {
            id,
            api
          };
  };

  const highlight = (id: string) => {
    itemRefs.current?.find((it) => it?.id === id)?.api?.highlight();
  };

  return { itemsToHighlight: itemRefs.current, highlight, addRef };
}
